import { createStore } from 'vuex';
import auth from './modules/auth';
import streams from './modules/streams';
import drones from './modules/drones';
import objects from './modules/objects';
import admin from './modules/admin';
import reports from './modules/reports';
import portal from './modules/portal';

export default createStore({
  modules: {
    auth,
    streams,
    drones,
    objects,
    admin,
    reports,
    portal,
  }
});
